import { call, put } from "redux-saga/effects";
import * as Api from "../../api";
import * as actions from "../actions";
import { setDavinFoodsQuizLoading } from "../actions/davinFoodsActions";

export function* markDocumentReadDavinFoods({ payload }) {
  yield put(actions.setDavinFoodsReadingLoading(true));
  try {
    yield call(Api.markDocumentRead, {
      document_read: payload,
      davinFoods: true,
    });
    yield put(actions.setDavinFoodsReadingLoading(false));
  } catch (error) {
    yield put(actions.addError("Reading List Davin Foods", error));
    yield put(actions.setDavinFoodsReadingLoading(false));
  }
}

export function* submitDavinFoodsQuizSaga({ payload }) {
  const { formName, formContent } = payload;
  yield put(actions.setDavinFoodsQuizLoading(formName));
  try {
    const response = yield call(
      Api.submitDavinFoodsQuiz,
      formName,
      formContent
    );
    yield put(actions.setDavinFoodsQuizResults(response.data));
    yield put(actions.setDavinFoodsQuizLoading(""));
    yield put(actions.setDavinFoodsQuizShowResults(formName));
  } catch (error) {
    yield put(actions.addError("Submit Davin Foods Quiz", error));
    yield put(actions.setDavinFoodsQuizLoading(""));
  }
}

export function* submitDavinFoodsFormSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    yield call(Api.submitDavinFoodsForm, formName, formContent);
  } catch (error) {
    yield put(actions.addError("Submit Davin Foods Form error", error));
  }
}
export function* postDavinFoodsFormSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    yield call(Api.postDavinFoodsForm, formName, formContent);
  } catch (error) {
    yield put(actions.addError("Post Davin Foods Form error", error));
  }
}
